module.exports = __webpack_public_path__ + "static/gradienta-a8e5b430898f3170d42032b83fc34b8e.jpg";